import { createReducer } from "reduxsauce"
import { get, pick } from "lodash"
import actionCreator from "helpers/actionCreator"
import { Types as ParentTypes } from "modules/analyze-composition/model"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { DESC, orderState, handleSort } from "helpers/sorts"
import { Types as LoaderTypes } from "model/graphql"
import { ANALYZE_SECTION, createAnalyzeGroupingAndFilterReducer } from "helpers/analyze"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeConcentrationDetails", {
  show: {
    props: ["contributor"],
    track: true,
    trackType: "analyze-concentration-contributors-category-selected",
    trackPayload: ({ contributor: { label } }) => ({ type: label }),
  },
  hide: [],
  sort: {
    props: ["order"],
    track: true,
    trackType: "analyze-concentration-contributors-sorting",
    trackPayload: ({ order }) => order,
  },
  showGroup: {
    props: ["group"],
    track: true,
    trackType: "analyze-concentration-contributors-group-selected",
    trackPayload: ({ group: { name } }) => ({ label: name }),
  },
  hideGroup: [],
  openBasket: ["ticker"],
  closeBasket: [],
  showBasketGroup: {
    props: ["basketGroup"],
    track: true,
    trackType: "analyze-concentration-basket-contributors-group-selected",
    trackPayload: ({ group: { name } }) => ({ label: name }),
  },
  hideBasketGroup: [],
  setContributorsGrouping: {
    props: ["grouping"],
    track: true,
    trackType: "analyze-concentration-contributors-grouping-option-selected",
    trackPayload: ({ grouping }) => {
      let by
      if (grouping) {
        by = grouping.classificationId
          ? `${grouping.classificationId} - ${grouping.id}` : grouping.id
      }
      return { by }
    },
  },
  groupSort: {
    props: ["order"],
    track: true,
    trackType: "analyze-concentration-contributors-group-sorting",
    trackPayload: ({ order }) => ({ order }),
  },
})

const defaultOrder = orderState("viewType", DESC)

const DEFAULT_STATE = {
  selected: null,
  selectedBasket: null,
  selectedGroup: null,
  selectedBasketGroup: null,
  order: defaultOrder,
  contributorsGrouping: null,
  groupOrder: {
    by: "value",
    order: "desc",
  },
}

function handleShow(state, { contributor }) {
  return { ...state, selected: contributor }
}

function handleHide(state) {
  return {
    ...state,
    selected: null,
    order: defaultOrder,
  }
}

function handleShowGroup(state, { group }) {
  return { ...state, selectedGroup: pick(group, ["id", "name", "description"]) }
}

function handleHideGroup(state) {
  return { ...state, selectedGroup: null }
}

function handleGroupSort(state, { order }) {
  return { ...state, groupOrder: { ...state.groupOrder, order } }
}

function handleSetContributorsGrouping(state, { grouping }) {
  let contributorsGrouping
  if (grouping) {
    contributorsGrouping = grouping
  }
  return {
    ...state,
    contributorsGrouping,
    selectedGroup: null,
    selectedBasketGroup: null,
  }
}

function handleOpenBasket(state, { ticker }) {
  const isGroupedByTag = get(state, "contributorsGrouping.isTag")
  let contributorsGrouping = state.contributorsGrouping
  let selectedGroup = state.selectedGroup

  if (isGroupedByTag) {
    contributorsGrouping = null
    selectedGroup = null
  }

  return {
    ...state,
    contributorsGrouping,
    selectedGroup,
    selectedBasket: { ticker },
  }
}

function handleCloseBasket(state) {
  return {
    ...state,
    selectedBasket: null,
    selectedBasketGroup: null,
  }
}

function handleShowBasketGroup(state, { basketGroup }) {
  return { ...state, selectedBasketGroup: pick(basketGroup, ["id", "name", "description"]) }
}

function handleHideBasketGroup(state) {
  return { ...state, selectedBasketGroup: null }
}

function handleSetModel(state) {
  return { ...state, ...DEFAULT_STATE }
}

const handleLoadSuccess = (state, action) => {
  if (action.resource === "concentrationContributors") {
    return { ...state, selectedBasket: null, selectedBasketGroup: null }
  }

  return state
}

export default createReducer(DEFAULT_STATE, {
  [Types.SORT]: handleSort,
  [Types.SHOW]: handleShow,
  [Types.HIDE]: handleHide,
  [Types.SHOW_GROUP]: handleShowGroup,
  [Types.HIDE_GROUP]: handleHideGroup,
  [Types.SET_CONTRIBUTORS_GROUPING]: handleSetContributorsGrouping,
  [Types.OPEN_BASKET]: handleOpenBasket,
  [Types.CLOSE_BASKET]: handleCloseBasket,
  [Types.SHOW_BASKET_GROUP]: handleShowBasketGroup,
  [Types.HIDE_BASKET_GROUP]: handleHideBasketGroup,
  [Types.GROUP_SORT]: handleGroupSort,
  [ParentTypes.SET_DISPLAY_TYPE]: handleHide,
  [BaseTypes.SET_MODEL]: handleSetModel,
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  ...createAnalyzeGroupingAndFilterReducer(ANALYZE_SECTION.TRENDS),
})
